export default __webpack_public_path__ + "49a80c962dabe3939d622f18f4fe470c.jpg";